import { Box, Skeleton } from '@factorialco/deprecated-design-system'

const MessageContentSkeleton = () => (
  <Box gap="s16">
    <Skeleton width="s64" height="s16" />
    <Skeleton width="full" height="s16" />
    <Skeleton width="s600" height="s16" />
    <Skeleton width="s300" height="s16" />
    <Skeleton width="s240" height="s16" />
    <Skeleton width="s240" height="s16" />
    <Skeleton width="s240" height="s16" />
    <Skeleton width="full" height="s16" />
    <Skeleton width="s600" height="s16" />
    <Skeleton width="s64" height="s16" />
    <Skeleton width="s64" height="s16" />
  </Box>
)

export default MessageContentSkeleton
